import { useState, useEffect, useRef } from 'react';
import { IonModal, IonButton, IonIcon, IonText, IonSegment, IonSegmentButton, IonLabel, useIonToast } from '@ionic/react';
import { add, remove } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { Storage } from '@capacitor/storage';
import { TranslateCabin } from '../../../defines/Functions';
import './FlightPassenger.css';


interface Props {
    flightPassengerParentCallback: Function
}
const FlightPassengerModal = (props: Props) => {
    const [present] = useIonToast();
    const [state, setState] = useState({
        showFlightPassengerModal: false,
        countAdults: 1,
        countChilds: 0,
        countInfants: 0,
        cabinClass: "Economy"
    })
    const showToast = (options: any) => {
        present({
            buttons: [{ icon: 'close', role: 'cancel' }],
            message: options.message,
            color: options.color,
            duration: 2000
        })
    }
    const flightPassengerCallback = () => {
        let flightPassengerParentCallbackValue = state.cabinClass + ',' + state.countAdults + ',' + state.countChilds + ',' + state.countInfants;
        props.flightPassengerParentCallback(flightPassengerParentCallbackValue);
    }
    const updatePassenger = (type: string, action: string) => {
        let countAdults = state.countAdults;
        let countChilds = state.countChilds;
        let countInfants = state.countInfants;
        if (action === 'plus') {
            if (type === 'adults') {
                countAdults = countAdults + 1;
                if ((countAdults + countChilds) > Constants.flightMaxPassengers) {
                    showToast({ message: 'حداکثر تعداد بزرگسال و کودک : ' + (countAdults + countChilds - 1), color: 'danger' });
                    return;
                }
            } else if (type === 'childs') {
                countChilds = countChilds + 1;
                if ((countAdults + countChilds) > Constants.flightMaxPassengers) {
                    showToast({ message: 'حداکثر تعداد بزرگسال و کودک : ' + (countAdults + countChilds - 1), color: 'danger' });
                    return;
                }
            } else if (type === 'infants') {
                countInfants = countInfants + 1;
                if (countInfants > countAdults) {
                    countInfants = countAdults;
                    showToast({ message: 'حداکثر تعداد نوزاد مجاز : ' + countAdults, color: 'danger' });
                    return;
                }
            }
        } else {
            if (type === 'adults') {
                countAdults = countAdults - 1;
                if (countAdults === 0) {
                    countAdults = 1;
                    showToast({ message: 'حداقل تعداد بزرگسال : 1 نفر', color: 'danger' });
                }
                if (countInfants > countAdults) {
                    countInfants = countAdults;
                }
            } else if (type === 'childs') {
                countChilds = countChilds - 1;
            } else if (type === 'infants') {
                countInfants = countInfants - 1;
            }
        }
        if (countAdults >= 1 && countChilds >= 0 && countInfants >= 0) {
            setState({ ...state, countAdults: countAdults, countChilds: countChilds, countInfants: countInfants });
        }

    }
    const onCloseModal = () => {
        setState({ ...state, showFlightPassengerModal: false });
        flightPassengerCallback();
    }
    const didGetFlightJson = useRef(false);
    useEffect(() => {
        if (!didGetFlightJson.current) {
            const getFlightJson = async () => {
                const { value } = await Storage.get({ key: 'flightJson' });
                if (value !== null) {
                    const objectValue = JSON.parse(value);
                    let passengersAdults = objectValue.passengers.adults;
                    let passengersChilds = objectValue.passengers.childs;
                    let passengersInfants = objectValue.passengers.infants;
                    let cabinClass = objectValue.other.cabin;
                    setState({ ...state, countAdults: passengersAdults, countChilds: passengersChilds, countInfants: passengersInfants, cabinClass: cabinClass });
                }
            };
            getFlightJson();
            didGetFlightJson.current = true;
        }
    }, [state]);
    return (
        <div>
            <IonModal isOpen={state.showFlightPassengerModal} onDidDismiss={onCloseModal} swipeToClose={false} mode="md" cssClass="flight-passenger-modal" backdropDismiss>
                <div className="flight-passenger-modal-items">
                    <div className="flight-passenger-modal-item">
                        <IonIcon icon={add} className="flight-passenger-modal-icon-add" onClick={() => updatePassenger('adults', 'plus')} />
                        <div>
                            بزرگسال
                            <small>(12 سال به بالا)</small>
                            <span>{state.countAdults}</span>
                        </div>
                        <IonIcon icon={remove} className={state.countAdults === 1 ? "flight-passenger-modal-icon-remove disabled" : "flight-passenger-modal-icon-remove"} onClick={() => updatePassenger('adults', 'minus')} />
                    </div>
                    <div className="flight-passenger-modal-item">
                        <IonIcon icon={add} className="flight-passenger-modal-icon-add" onClick={() => updatePassenger('childs', 'plus')} />
                        <div>
                            کودک
                            <small>(2 تا 12 سال)</small>
                            <span>{state.countChilds}</span>
                        </div>
                        <IonIcon icon={remove} className={state.countChilds === 0 ? "flight-passenger-modal-icon-remove disabled" : "flight-passenger-modal-icon-remove"} onClick={() => updatePassenger('childs', 'minus')} />
                    </div>
                    <div className="flight-passenger-modal-item">
                        <IonIcon icon={add} className="flight-passenger-modal-icon-add" onClick={() => updatePassenger('infants', 'plus')} />
                        <div>
                            نوزاد
                            <small>(زیر 2 سال)</small>
                            <span>{state.countInfants}</span>
                        </div>
                        <IonIcon icon={remove} className={state.countInfants === 0 ? "flight-passenger-modal-icon-remove disabled" : "flight-passenger-modal-icon-remove"} onClick={() => updatePassenger('infants', 'minus')} />
                    </div>
                    <IonSegment mode="ios" onIonChange={e => setState({ ...state, cabinClass: e.detail.value! })} value={state.cabinClass}>
                        <IonSegmentButton value="Economy">
                            <IonLabel>اکونومی</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="Business">
                            <IonLabel>بیزینس کلاس</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="First">
                            <IonLabel>فرست کلاس</IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                </div>
                <IonButton color="warning" onClick={onCloseModal} className="flight-passenger-modal-close-btn">تایید</IonButton>
            </IonModal>
            <IonText onClick={() => setState({ ...state, showFlightPassengerModal: true })}>
                {state.countAdults} بزرگسال / {state.countChilds} کودک / {state.countInfants} نوزاد / {TranslateCabin(state.cabinClass)}
            </IonText>
        </div>
    );
};
export default FlightPassengerModal;